import React from 'react';
import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { useSelector } from 'react-redux';
import { wingProjectPiviotTableHeader } from '../utils/wingProjectPiviotTableHeader';

const TeamSubjectTable = () => {
  const wingProjectPivot = useSelector((state) => state.pointTracker.wingProjectPivot.data);
  const wingProjectPivotLoading = useSelector((state) => state.pointTracker.wingProjectPivot.loading);

  return (
    <GlobalTableGenerator
      rows={wingProjectPivot?.wings || []}
      loading={wingProjectPivotLoading}
      columns={wingProjectPiviotTableHeader}
      TableHeadStyle={{ bgcolor: '#00b8dc' }}
      TableContainerStyle={{
        border: '1px solid #00b8dc',

        '& .MuiTableCell-head': {
          border: '1px solid #0094bd',
        },
      }}
    />
  );
};
export default React.memo(TeamSubjectTable);
